import React from 'react';
import { Helmet } from 'react-helmet';
import { Button, Modal } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
// @ts-ignore
import DatePagination from 'components/DatePagination';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import CurrentMyTimesheetIsEditable from 'components/CurrentMyTimesheetIsEditable';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import QueryStringButton from 'components/QueryStringButton';
import QueryStringModal from 'components/QueryStringModal';
import RoleGate from 'components/RoleGate';
import MyTimesheetsExistsGate from 'components/MyTimesheetsExistsGate';
import MyTimesheetEntriesWeekTotal from 'components/MyTimesheetEntriesWeekTotal';

// Global Constants
import {
    ADMIN,
    ASSISTANT_MANAGER,
    FIELD_STAFF,
    SUPERVISOR,
    MANAGER
} from 'components/RoleGate/constants';

// Local Components
import UserPersonId from 'components/UserPersonId';
import MyTimesheetEntriesCard from './components/MyTimesheetEntriesCard';
import MyTimesheetEntriesDayButton from './components/MyTimesheetEntriesDayButton';
import MyTimesheetEntriesRequest from './components/MyTimesheetEntriesRequest';
import MyTimesheetEntryFinalForm from './components/MyTimesheetEntryFinalForm';
import MyTimesheetLoadingGate from './components/MyTimesheetLoadingGate';
import MyTimesheetEntriesDeleteModal from './components/MyTimesheetEntriesDeleteModal';
import MyTimesheetEntriesErrorMessage from './components/MyTimesheetEntriesErrorMessage';

// Local Constants
import { QUERY_STRING_PARAM } from './constants';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

function MyTimesheets(): React.ReactElement {
    return (
        <MyTimesheetsExistsGate>
            <React.Fragment>
                <Helmet>
                    <title>My Timesheets - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <Online>
                    <MyTimesheetEntriesRequest />
                </Online>
                <PageTitleAndFilters
                    title="My Timesheets"
                    CustomSearch={<DatePagination numberOfDays={7} />}
                    hideFilters
                    Button={
                        <RoleGate
                            requiredRoles={[
                                ADMIN,
                                MANAGER,
                                ASSISTANT_MANAGER,
                                FIELD_STAFF,
                                SUPERVISOR
                            ]}
                        >
                            <CurrentMyTimesheetIsEditable>
                                <QueryStringButton
                                    params={{
                                        [QUERY_STRING_PARAM]: true,
                                        myTimesheetEntryUuid: undefined
                                    }}
                                >
                                    Create Entry
                                </QueryStringButton>
                            </CurrentMyTimesheetIsEditable>
                        </RoleGate>
                    }
                />
                <ErrorBoundary
                    namespace="MyTimesheets"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <PageWrapper
                        top={0}
                        bottom={50}
                        width={810}
                        style={{ position: 'relative' }}
                    >
                        <MyTimesheetEntriesErrorMessage />
                        <MyTimesheetLoadingGate>
                            <React.Fragment>
                                <MyTimesheetEntriesWeekTotal />
                                <Button.Group fluid primary icon size="medium">
                                    {[0, 1, 2, 3, 4, 5, 6].map((dayOfWeek) => (
                                        <MyTimesheetEntriesDayButton
                                            key={dayOfWeek}
                                            dayOfWeek={dayOfWeek}
                                        />
                                    ))}
                                </Button.Group>
                                <MyTimesheetEntriesCard />
                            </React.Fragment>
                        </MyTimesheetLoadingGate>
                    </PageWrapper>
                    <QueryStringModal param={QUERY_STRING_PARAM}>
                        <React.Fragment>
                            <Modal.Header>Timesheet Entry</Modal.Header>
                            <Modal.Content className="constrain-width">
                                <UserPersonId>
                                    {(userPersonId) => (
                                        <MyTimesheetEntryFinalForm
                                            personId={userPersonId}
                                        />
                                    )}
                                </UserPersonId>
                            </Modal.Content>
                        </React.Fragment>
                    </QueryStringModal>
                    <MyTimesheetEntriesDeleteModal />
                </ErrorBoundary>
            </React.Fragment>
        </MyTimesheetsExistsGate>
    );
}

export default MyTimesheets;
